import script from "./SubscriptionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionSettings.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionSettings.vue?vue&type=style&index=0&id=a168b23e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a168b23e"]])

export default __exports__